import React, { useState } from 'react'

interface TextAreaProps {
  disabled?: boolean
  placeholder?: string
  value?: string
  onChange?: (event: React.ChangeEvent<HTMLTextAreaElement>) => void
  ref?: React.Ref<HTMLTextAreaElement>
  className?: string;
  padding?: boolean;
  cols?: number;
}

function BaseTextArea({
  disabled = false,
  placeholder = "",
  value = undefined,
  onChange = undefined,
  className = "",
  padding = true,
  ref = undefined,
  cols = 1
}: TextAreaProps) {
  const [body, setBody] = useState("");
  function handleChange(event: React.ChangeEvent<HTMLTextAreaElement>) {
    setBody(event.target.value)
  }

  return (
    <div
      className={'grid text-grow font-mono ' + className}
      data-replicated-value={value == undefined ? body : value}>
      <textarea
        ref={ref}
        cols={cols}
        disabled={disabled}
        className={
          'text-grow-gridarea w-full bg-transparent border-none outline-none resize-none overflow-hidden placeholder:text-outline ' +
          (padding ?
            'p-2 ' :
            ''
          )
        }
        placeholder={placeholder}
        value={value == undefined ? body : value}
        onChange={
          onChange == undefined ? handleChange : onChange
        }
      />
    </div>
  )
}

export default BaseTextArea